// Retour haptique du magnétisme.
//
// Le web n'expose qu'une seule API haptique : navigator.vibrate (Android /
// Chrome mobile). iOS Safari, macOS et Windows ne l'implémentent pas — le
// helper détecte l'absence et devient un no-op silencieux, il ne faut donc
// jamais faire dépendre un comportement visuel de sa valeur de retour.
//
// Deux protections, sans lesquelles le moteur vibre en continu : un verrou sur
// l'empreinte de l'alignement courant (on ne pulse qu'au FRANCHISSEMENT d'un
// snap, pas tant qu'on y reste collé) et un cooldown temporel (tremblement de
// souris autour du seuil = accrochages/décrochages en rafale).

import { SNAP_CONFIG } from './snapConfig';

let lastSignature = '';
let lastPulseAt = -Infinity;

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const vibrate = () => {
  const nav = typeof navigator === 'undefined' ? null : navigator;
  if (!nav || typeof nav.vibrate !== 'function') return false;
  try {
    return nav.vibrate(SNAP_CONFIG.hapticPattern) === true;
  } catch {
    // Certains navigateurs lèvent si l'onglet n'a jamais reçu d'interaction.
    return false;
  }
};

/**
 * À appeler à chaque frame de drag avec l'empreinte des guides actifs
 * (`guidesSignature`). Ne déclenche une impulsion que si l'alignement a
 * réellement changé et que le cooldown est écoulé.
 *
 * @param {string} signature empreinte courante, '' quand aucun snap n'est actif
 * @param {number} now horloge injectable (tests)
 * @returns {boolean} true si une impulsion a été émise
 */
export const pulseOnSnapChange = (signature, now = Date.now()) => {
  if (!SNAP_CONFIG.enableHaptics) return false;
  // Snap perdu : on réarme sans vibrer, pour que le retour du MÊME alignement
  // repulse (sinon un aller-retour sur un guide deviendrait muet).
  if (!signature) {
    lastSignature = '';
    return false;
  }
  if (signature === lastSignature) return false;
  if (now - lastPulseAt < SNAP_CONFIG.hapticCooldown) {
    // Cooldown : on ne vibre pas, et on ne mémorise pas non plus l'empreinte,
    // pour que l'alignement soit encore « neuf » à la frame suivante.
    return false;
  }
  lastSignature = signature;
  lastPulseAt = now;
  if (prefersReducedMotion()) return false;
  return vibrate();
};

// Fin de drag : le prochain alignement doit vibrer, quel qu'il soit.
export const resetHaptics = () => {
  lastSignature = '';
  lastPulseAt = -Infinity;
};
